import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import notificationSendView from './components/Notifications.vue'
import challengeView from './components/Challenges.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: notificationSendView
      // route level code-splitting
    //   // this generates a separate chunk (notifications.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "notifications" */ './components/Notifications.vue')
    },
    {
      path: '/cards',
      name: 'cards',
      // route level code-splitting
      // this generates a separate chunk (cards.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "cards" */ './components/Cards.vue')
    },
    {
      path: '/contests',
      name: 'contests',
      // route level code-splitting
      // this generates a separate chunk (contests.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "contests" */ './components/Contests.vue')
    },
    {
      path: '/budget',
      name: 'budget',
      // route level code-splitting
      // this generates a separate chunk (budget.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "budget" */ './components/Budget.vue')
    },
    {
      path: '/blacklist',
      name: 'blacklist',
      // route level code-splitting
      // this generates a separate chunk (blacklist.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "blacklist" */ './components/UserBlacklist.vue')
    },
    {
      path: '/fis',
      name: 'fis',
      // route level code-splitting
      // this generates a separate chunk (fis.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "fis" */ './components/FinancialInstitutions.vue')
    },
    {
      path: '/users',
      name: 'users',
      // route level code-splitting
      // this generates a separate chunk (users.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "users" */ './components/Users.vue')
    },
    {
      path: '/userverify',
      name: 'userverify',
      // route level code-splitting
      // this generates a separate chunk (users.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "users" */ './components/UserVerify.vue')
    },
    {
      path: '/affiliates',
      name: 'affiliates',
      // route level code-splitting
      // this generates a separate chunk (affiliates.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "affiliates" */ './components/Affiliates.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/callback',
      name: 'Callback',
      // route level code-splitting
      // this generates a separate chunk (callback.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "callback" */ './components/Callback.vue')
    },
    {
      path: '/profile',
      name: 'Profile',
      // route level code-splitting
      // this generates a separate chunk (profile.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "profile" */ './components/Profile.vue')
    },
    {
      path: '/messages',
      name: 'Messages',
      // route level code-splitting
      // this generates a separate chunk (messages.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "messages" */ './components/Messages.vue')
    },
    {
      path: '/payment-admin',
      name: 'Payment Admin',
      // route level code-splitting
      // this generates a separate chunk (paymentAdmin.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "paymentAdmin" */ './components/PaymentAdmin.vue')
    },
    {
      path: '/vendor-admin',
      name: 'Vendor Admin',
      // route level code-splitting
      // this generates a separate chunk (vendorAdmin.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "vendorAdmin" */ './components/VendorAdmin.vue')
    },
    {
      path: '/challenges',
      name: 'challenges',
      component: challengeView
    //   // route level code-splitting
    //   // this generates a separate chunk (challenges.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "challenges" */ './components/Challenges.vue')
    },
    {
      path: '/questionnaires',
      name: 'questionnaire',
      // route level code-splitting
      // this generates a separate chunk (questionnaire.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "questionnaire" */ './components/Questionnaire.vue')
    },
    {
      path: '/user-reports',
      name: 'User Reports',
      // route level code-splitting
      // this generates a separate chunk (userReports.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "userReports" */ './components/user/UserReports.vue')
    },

    {
      path: '/questionnairev2',
      name: 'QuestionnaireV2',
      // route level code-splitting
      // this generates a separate chunk (questionnairev2.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "questionnairev2" */ './components/QuestionnaireV2.vue')
    },

    {
      path: '/groups',
      name: 'Groups',
      component: () =>
        import(/* webpackChunkName: "users" */ './components/Groups.vue')
    },

    {
      path: '/reports',
      name: 'Reports',
      component: () =>
        import('./components/Reports.vue')
    }

  ]
})
